module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('AppAddItemButtonBase', {
    attrs: {
      "itemTypeID": _vm.itemType
    },
    scopedSlots: _vm._u([{
      key: "itemInputField",
      fn: function(props) {
        return [_c('v-text-field', {
          attrs: {
            "placeholder": "Service name"
          },
          model: {
            value: (props.model.name),
            callback: function($$v) {
              _vm.$set(props.model, "name", $$v)
            },
            expression: "props.model.name"
          }
        })]
      }
    }])
  }, [_c('template', {
    slot: "title"
  }, [_vm._v("\n    Add Service\n  ")])], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-da348bb0","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/buttons/AddServiceButton.vue
// module id = 1032
// module chunks = 1